import type { ButtonHTMLAttributes } from "react";
import css from "./primitives.module.css";

type ChipProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  active?: boolean;
};

/**
 * §7 filter row: "franchise chips (mono 11.5px, 7x11px padding, active gold on
 * void-ink text, inactive --panel/periwinkle)". A button, not a div - §10
 * requires every filter to be keyboard-operable.
 */
export function Chip({ active, className, type = "button", ...rest }: ChipProps) {
  const classes = [css.chip, active ? css.chipActive : "", className ?? ""]
    .filter(Boolean)
    .join(" ");
  return <button type={type} aria-pressed={active} className={classes} {...rest} />;
}
